<template>
  <div id="changeForgottenPassword">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="4" md="4" class="change-password_slim">
          <v-card elevation="10" class="change_password_card">
            <v-card-text class="change-password">
              <v-alert v-if="!!messageOk" type="success"> {{ messageOk }}</v-alert>
              <v-alert v-if="!!message" type="error"> {{ message }}</v-alert>
              <div v-if="!showForm && loadingCheckToken">
                <h2>Prebieha kontrola tokenu!</h2>
              </div>
              <v-form
                ref="cpform"
                id="change-password-form"
                @submit.prevent="submitchange - password"
                autocomplete="off"
                v-if="showForm"
              >
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="8" md="8">
                    <h1 class="change-password_prihlasenie">Zmeniť heslo</h1>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center" no-gutters>
                  <v-col cols="12" sm="8" md="8">
                    <form-component title="">
                      <v-text-field
                        v-model="pin"
                        type="text"
                        :label="'SMS PIN'"
                        class="dynamic-input-control"
                        outlined
                      ></v-text-field>
                    </form-component>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center" no-gutters>
                  <v-col cols="12" sm="8" md="8">
                    <form-component title="">
                      <v-text-field
                        v-model="password_new1"
                        :append-icon="showPass_new1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.password_new1]"
                        :type="showPass_new1 ? 'text' : 'password'"
                        :label="'Nové heslo'"
                        class="dynamic-input-control"
                        outlined
                        @click:append="showPass_new1 = !showPass_new1"
                      ></v-text-field>
                    </form-component>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center" no-gutters>
                  <v-col cols="12" sm="8" md="8">
                    <form-component title="">
                      <v-text-field
                        v-model="password_new2"
                        :append-icon="showPass_new2 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.password_new2]"
                        :type="showPass_new2 ? 'text' : 'password'"
                        :label="'Zopakujte heslo'"
                        class="dynamic-input-control"
                        outlined
                        @click:append="showPass_new2 = !showPass_new2"
                      ></v-text-field>
                    </form-component>
                  </v-col>
                </v-row>
              </v-form>
              <v-row align="center" justify="center" class="">
                <v-col cols="12" sm="8" md="8" v-if="showForm">
                  <v-btn
                    class="btn-primary mt-20px right"
                    @click="changePassword()"
                    v-bind:loading="loading"
                    >Zmeniť heslo</v-btn
                  >
                  <v-btn
                    class="btn-secondary mt-20px mr-20px right"
                    to="/"
                    @click="changePasswordCancel"
                    >Zrušiť</v-btn
                  >
                </v-col>
                <v-col cols="12" sm="12" md="12" v-else>
                  <v-btn
                    class="btn-secondary mt-20px mr-20px right"
                    to="/"
                    @click="changePasswordCancel"
                    >Zatvoriť</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import FormComponent from '../components/FormComponent.vue';
import protectedAxios from '../auth/axios.js';
import TextBox from '../components/basic/TextBox.vue';

export default {
  components: {
    FormComponent,
    TextBox,
  },
  data() {
    return {
      showForm: false,
      loadingCheckToken: false,
      loading: false,
      showPass_new1: false,
      showPass_new2: false,
      pin: '',
      email_token: '',
      password_new1: '',
      password_new2: '',
      message: '',
      messageOk: '',
      rules: {
        password_new1: value => !!value || 'Zadajte nové heslo!',
        password_new2: value => !!value || 'Zopakujte nové heslo!',
      },
    };
  },
  mounted() {
    this.email_token = this.$route.params.hash;
    this.checkToken();
  },
  methods: {
    checkToken() {
      this.showForm = false;
      this.loadingCheckToken = true;

      protectedAxios
        .post('/login/send-sms', {
          Token: this.email_token,
        })
        .then(res => {
          if (res.data.status != 0) {
            this.message = res.data.message;
            this.messageOk = '';
            if (res.data.status === 404) this.showForm = false;
          } else {
            this.showForm = true;
          }
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          this.loadingCheckToken = false;
        });
    },
    changePassword() {
      this.loading = true;
      protectedAxios
        .post('/login/set-password', {
          Token: this.email_token,
          Pin: this.pin,
          NewPass1: this.password_new1,
          NewPass2: this.password_new2,
        })
        .then(res => {
          if (res.data.status != 0) {
            this.message = res.data.message;
            this.messageOk = '';
            if (res.data.status === 404) this.showForm = false;
          } else {
            //this.lostPassword = !this.lostPassword;
            this.message = '';
            this.messageOk = res.data.message;
            this.pin = '';
            this.password_new1 = '';
            this.password_new2 = '';
            this.showPass_new1 = false;
            this.showPass_new2 = false;
            this.$refs.cpform.resetValidation();
            this.showForm = false;
          }
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changePasswordCancel() {
      //console.log('changePasswordCancel');
    },
  },
};
</script>
<style lang="sass"></style>
